import { WifiOff } from 'lucide-react';
import { useLiveQuery } from 'dexie-react-hooks';
import { useAuth } from '@/auth/store';
import { db } from '@/db/db';
import { useOnline } from '@/lib/useOnline';

/** Offline is a state, not an event: a quiet badge in the top bar (8m). The outbox count joins it with sync (Phase 2). */
export function OfflineBadge() {
  const online = useOnline();
  const signedIn = useAuth((s) => s.status === 'signedIn');
  const pending = useLiveQuery(() => db.outbox.count(), [], 0) ?? 0;
  if (online) return null;
  return <span className="inline-flex items-center gap-[6px] h-[30px] px-3 rounded-pill bg-pill-bg text-pill-fg text-[12px] font-bold" title="The timer doesn't need the network. Sessions queue on this device and upload the moment you're back."><WifiOff size={12} /><span className="hidden sm:inline">Offline{signedIn && pending > 0 ? ` · ${pending} to sync` : ''}</span></span>;
}
